import { Card, Typography } from "@mui/material";
import { CardContent } from "@mui/material";

const AddressListItem = ({ address }) => {
	return (
		<Card className="w-full rounded-20 shadow cursor-pointer">
			<CardContent className="flex flex-col flex-auto px-12">
				<Typography className="pt-16" color="inherit">
					<span className="font-semibold">
						{`${address.firstName} ${address.lastName}`}
					</span>
				</Typography>
				<Typography className="font-normal" color="inherit">
					{address.addressLine1}
				</Typography>
				<Typography className="font-normal" color="inherit">
					{address.addressLine2}
				</Typography>
				<Typography className="font-normal" color="inherit">
					{`${address.city}, ${address.state.name} ${address.zipCode}`}
				</Typography>
				<Typography className="font-normal" color="inherit">
					{address.country.name}
				</Typography>
			</CardContent>
		</Card>
	);
};

export default AddressListItem;
